module.exports = __webpack_public_path__ + "kudos_73.svg?b77a93bc526d785ed6a5fc314f25b323";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_73.svg
// module id = 176
// module chunks = 0